import { render, staticRenderFns } from "./relevantTweets.vue?vue&type=template&id=0515ba24&"
import script from "./relevantTweets.vue?vue&type=script&lang=js&"
export * from "./relevantTweets.vue?vue&type=script&lang=js&"
import style0 from "./relevantTweets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports